import type { QuickSearchResultItem } from 'types/client/search';

import { route } from 'nextjs/routes';

import multichainConfig from 'configs/multichain';
import { isEvmAddress } from 'lib/address/isEvmAddress';

export function getSearchResultItemUrl(data: QuickSearchResultItem): string | undefined {
  const multichainContext = (() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chainInfo = 'chain_id' in data && multichainConfig()?.chains.find((chain) => chain.id === (data as any).chain_id);
    if (chainInfo) {
      return {
        chain: chainInfo,
      };
    }
  })();

  switch (data.type) {
    case 'token': {
      return route({ pathname: '/token/[hash]', query: { hash: data.address_hash } }, multichainContext);
    }
    case 'contract':
    case 'address':
    case 'label':
    case 'metadata_tag': {
      return route({ pathname: '/address/[hash]', query: { hash: data.address_hash, tab: 'txs' } });
    }
    case 'transaction': {
      return route({ pathname: '/tx/[hash]', query: { hash: data.transaction_hash } }, multichainContext);
    }
    case 'block': {
      const isFutureBlock = 'timestamp' in data && data.timestamp === undefined;
      if (isFutureBlock) {
        return route({ pathname: '/block/countdown/[height]', query: { height: String(data.block_number) } }, multichainContext);
      }

      const heightOrHash = data.block_hash || String(data.block_number);

      return route({ pathname: '/block/[height_or_hash]', query: { height_or_hash: heightOrHash } }, multichainContext);
    }
    case 'user_operation': {
      return route({ pathname: '/op/[hash]', query: { hash: data.user_operation_hash } });
    }
    case 'blob': {
      return route({ pathname: '/blobs/[hash]', query: { hash: data.blob_hash } });
    }
    case 'ens_domain': {
      return route({ pathname: '/address/[hash]', query: { hash: data.address_hash } });
    }
    case 'cluster': {
      if (isEvmAddress(data.address_hash)) {
        return route({ pathname: '/address/[hash]', query: { hash: data.address_hash } });
      }
      return undefined;
    }
    case 'tac_operation': {
      return route({ pathname: '/operation/[id]', query: { id: data.tac_operation.operation_id } });
    }
  }
}
